import React, { useEffect, useState } from "react";
import {
  useParams,
  Link,
  useLocation,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import ProductItem from "./ProductItem";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";

const filterOption = [
  {
    title: "Lọc Theo Giá",
    items: [
      {
        title: "Giá 500.000đ",
        operation: 0,
        value: 500000,
        start: 0,
        end: 0,
      },
      {
        title: "Mẫu 1.000.000đ",
        operation: 0,
        value: 1000000,
        start: 0,
        end: 0,
      },
      {
        title: "Mẫu 1.500.000đ",
        operation: 0,
        value: 1500000,
        start: 0,
        end: 0,
      },
      {
        title: "Mẫu 2.000.000đ",
        operation: 0,
        value: 2000000,
        start: 0,
        end: 0,
      },
      {
        title: "Mẫu Dưới 1.000.000đ",
        operation: 1,
        value: 1000000,
        start: 0,
        end: 0,
      },
      {
        title: "Từ 1.000.000đ - 1.500.000đ",
        operation: 2,
        value: 0,
        start: 1000000,
        end: 1500000,
      },
      {
        title: "Từ 1.500.000đ - 2.000.000đ",
        operation: 2,
        value: 0,
        start: 1500000,
        end: 2000000,
      },
      {
        title: "Từ 2.000.000đ - 3.000.000đ",
        operation: 2,
        value: 0,
        start: 2000000,
        end: 3000000,
      },
      {
        title: "Từ 3.000.000đ Trở Lên",
        operation: 3,
        value: 3000000,
        start: 0,
        end: 0,
      },
    ],
  },
  // {
  //   title: "Lọc Theo Tầng",
  //   items: [
  //     {
  //       title: "Kệ 1 Tầng",
  //       value: "",
  //     },
  //     {
  //       title: "Kệ 2 Tầng",
  //       value: "",
  //     },
  //     {
  //       title: "Kệ 3 Tầng",
  //       value: "",
  //     },
  //   ],
  // },
  // {
  //   title: "Màu Sắc",
  //   items: [
  //     {
  //       title: "Màu Cam",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Hồng",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Kem",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Trắng",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Tím",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Vàng",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Xanh",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Xanh Dương",
  //       value: "",
  //     },
  //     {
  //       title: "Màu Đỏ",
  //       value: "",
  //     },
  //     {
  //       title: "Nhiều Màu",
  //       value: "",
  //     },
  //     {
  //       title: "Đột Biến",
  //       value: "",
  //     },
  //   ],
  // },
];

const sortOption = [
  // {
  //   name: "Thứ tự theo mức độ phổ biến",
  //   value: "popular",
  // },
  // {
  //   name: "Thứ tự theo mức độ đánh giá",
  //   value: "review",
  // },
  {
    name: "Mới nhất",
    value: "new",
  },
  {
    name: "Thứ tự theo giá: thấp đến cao",
    value: "lowToHigh",
  },
  {
    name: "Thứ tự theo giá: cao đến thấp",
    value: "highToLow",
  },
];

const ProductList = () => {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedValue, setSelectedValue] = useState("new");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null);
  const [category, setCategory] = useState(``);
  const [products, setProducts] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTitle, setSearchTitle] = useState(``);
  const [keyword, setKeyword] = useState(``);
  const [loading, setLoading] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);
    if (location.pathname.startsWith("/tim-kiem")) {
      const keyword = searchParams.get("s");
      document.title = `Kết quả tìm kiếm của ${keyword} - Thanh flower`;
      setSearchTitle(`Kết quả tìm kiếm của: ${keyword}`);
      getProductList(null, null, keyword);
    } else {
      getCategoryTitle(slug);
    }
  }, [slug, currentPage, selectedValue, searchParams]);

  useEffect(() => {
    setCurrentPage(1);
    setActiveFilter(null);
  }, [slug]);

  const getCategoryTitle = (slug) => {
    axios
      .get(`/api/v1/categories/slug/` + slug)
      .then((res) => {
        if (res.data) {
          document.title = res.data.name + " - Thanh flower";
          setCategory(res.data);
          getProductList(res.data.id);
        } else {
          navigate(`/not-found`);
        }
      })
      .catch((err) => console.log(err));
  };

  const getProductList = (cateId = null, filterData = null, keyword = "") => {
    setKeyword(keyword);
    const params = {
      categoryId: cateId,
      limit: 9,
      page: currentPage,
      sortOption: selectedValue,
      keyword: keyword,
    };

    if (filterData) {
      if (filterData.operation !== undefined)
        params.operation = filterData.operation;
      if (filterData.value !== undefined) params.price = filterData.value;
      if (filterData.start !== undefined) params.priceStart = filterData.start;
      if (filterData.end !== undefined) params.priceEnd = filterData.end;
    }

    axios
      .get(`/api/v1/products`, { params })
      .then((res) => {
        setProducts(res.data.products);
        setTotalItems(res.data.totalItems);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add("no-scroll-y");
    } else {
      document.body.classList.remove("no-scroll-y");
    }
    return () => {
      document.body.classList.remove("no-scroll-y");
    };
  }, [isSidebarOpen]);

  const handleFilter = (data) => {
    setLoading(true);
    window.scrollTo(0, 0);
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
    if (activeFilter == data.title) {
      setActiveFilter(null);
      getProductList(category.id, null, keyword);
    } else {
      setActiveFilter(data.title);
      getProductList(category.id, data, keyword);
    }
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <Box sx={{ position: "relative", minHeight: "100vh" }}>
      <div className="product-list-container">
        <div className="product-list-top">
          {searchTitle == `` ? (
            <div className="product-list-breadcrumb">
              <Link to={`/`}>Trang chủ</Link>
              <div
                style={{ fontSize: 30, color: "#666666B2", cursor: "default" }}
              >
                {" "}
                •{" "}
              </div>
              <Link>{category.name}</Link>
            </div>
          ) : (
            <div className="product-list-breadcrumb">
              <Link>{searchTitle}</Link>
            </div>
          )}
          <div className="filter-button" onClick={toggleSidebar}>
            <i className="bi bi-funnel me-2"></i>Lọc
          </div>
          <div className="product-list-sort">
            <div className="result-number">
              Hiển thị {products.length} trên {totalItems} kết quả
            </div>
            <div className="select-sort">
              <select
                name="sort"
                id="sort"
                defaultValue={selectedValue}
                onChange={handleSelectChange}
              >
                {sortOption.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
              <i className="bi bi-chevron-down"></i>
            </div>
          </div>
        </div>
        <div className="product-list-layout">
          <div className="product-list-left">
            {filterOption.map((item, idx) => (
              <div className="filter-item" key={idx}>
                <div className="filter-title mb-4">{item.title}</div>
                {item.items.map((subItem, subIdx) => (
                  <p
                    className={activeFilter === subItem.title ? "active" : ""}
                    key={subIdx}
                    onClick={() => handleFilter(subItem)}
                  >
                    {subItem.title}
                  </p>
                ))}
              </div>
            ))}
          </div>
          {totalItems == 0 ? (
            <p style={{ textAlign: "center" }}>Không có sản phẩm tồn tại</p>
          ) : (
            <div>
              <div className="product-list-right">
                {products.map((item, idx) => (
                  <ProductItem data={item} key={idx} />
                ))}
              </div>
              <div className="pagination">
                <button
                  className={`page-button ${currentPage == 1 ? "active" : ""}`}
                  id="prev-btn"
                  disabled={currentPage == 1}
                  onClick={() => goToPage(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <span className="page-numbers">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      className={`page-number ${
                        index + 1 === currentPage ? "active" : ""
                      }`}
                      onClick={() => goToPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </span>
                <button
                  className={`page-button ${
                    currentPage == totalPages ? "active" : ""
                  }`}
                  id="next-btn"
                  disabled={currentPage == totalPages}
                  onClick={() => goToPage(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <div className="product-list-left-sidebar">
            {filterOption.map((item, idx) => (
              <div className="filter-item" key={idx}>
                <div className="filter-title mb-4">{item.title}</div>
                {item.items.map((subItem, subIdx) => (
                  <p
                    className={activeFilter === subItem.title ? "active" : ""}
                    key={subIdx}
                    onClick={() => handleFilter(subItem)}
                  >
                    {subItem.title}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Overlay */}
        {isSidebarOpen && (
          <div className="overlay" onClick={toggleSidebar}></div>
        )}
      </div>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <CircularProgress sx={{ color: "#0184b7" }} />
        </Box>
      )}
    </Box>
  );
};

export default ProductList;
